import { TaxIdFormat } from '../domains/tenant.domain';
import { getTaxIdHelper } from './tax-id-helper';

export const isEmailValid = (email: string) => {
  const emailRegex =
    /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  return email ? emailRegex.test(email.toLowerCase()) : true;
};

export const isPhoneNumberValid = (phoneNumber: string, minPhoneNumberLength: number) => {
  return phoneNumber.replace(/\D/g, '').length >= minPhoneNumberLength;
};

export const validateNationalId = (nationalId: string, taxIdFormat: TaxIdFormat, maxLength: number | undefined) => {
  if (!nationalId) return 'required';
  if (maxLength && nationalId.length > maxLength) return 'max_length';

  const isValid = getTaxIdHelper(taxIdFormat)?.isNationalIdValid(nationalId) ?? true;

  if (!isValid) return 'invalid';
  return undefined;
};
